/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import styles from "./ReviewConfirmation.module.scss";
// import ContinueCancelButtons from "../../../../shared/components/ContinueCancelButtons";
// import DebtInformationListTable from '../../DebtInformationList/components/DebinformationListTable'
import { Button } from "../../../../shared/components/RegularComponents";
import HomeAddressSummary from "./HomeAddressSummary";
import AnotherAdultSummary from "./AnotherAdultSummary";
import PersonalInfoSummary from "./PersonalInfoSummary";
import { useDispatch, useSelector } from "react-redux";
import { postHarpApplicationAPIAction } from "../../../../redux/reducers/apiReducers/postHarpApplicationReducer";
import { useNavigate } from "react-router-dom";
import BackAnchor from "../../../../shared/components/BackAnchor";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { CircularProgress } from "@mui/material";
import SignatureSummary from "./SignatureSummary";
import { setAppProperty, setQuestionAnswer } from "../../../../redux/actions";
import HomeHeatingSummary from "./HomeHeatingSummary";
import ConfirmationAndAgreementSummary from "./SharingConfirmationSummary";

const style = {
  position: "fixed",
  top: "20%",
  left: "50%",
  // zIndex: "1000",
  overflowY: "auto",
  // display: "flex",
  // justifyContent: "center",
  transform: "translate(-50%, -20%)",
  // height: '40%',
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4
};

const ReviewConfirmationView = ({ t, i18n, setIsError }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const appData = useSelector((state) => state.app);
  const harpDataError = useSelector(
    (state) => state.harpApplicationReducer.error
  );
  const [errMsg, setErrorMessage] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const datesData = useSelector((state) => state.datesReducer);
  let currentLanguageDates;
  if (datesData) {
    currentLanguageDates = datesData[i18n.language];
  }

  const otherAdultsInformation = appData.otherAdultsInformation;
  const otherAdultAssessmentFiles = appData.otherAdultAssessmentFiles;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (harpDataError) {
      setErrorMessage(harpDataError);
    }
  }, [harpDataError]);

  const handleCancel = () => {
    // const url =
    //   i18n.language === "en"
    //     ? process.env.REACT_APP_PAGE_NOT_FOUND_URL
    //     : process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR;

    // window.location.replace(url);
    navigate(
      `/${i18n.language}${t("routes.cancel_confirmation")}`
    );
  };

  const onContinueClick = async () => {
    dispatch(
      setAppProperty(
        "appLanguage",
        i18n.language === "en" ? "ENGLISH" : "FRENCH"
      )
    );
    setDisableSubmit(true);
    setIsActive(true);
    appData.appLanguage = i18n.language === "en" ? "ENGLISH" : "FRENCH";
    window.scrollTo(0, 0, "smooth");
    // sessionStorage.setItem('BUTTON-DISABLE', 'true')
    try {
      await dispatch(postHarpApplicationAPIAction(appData, i18n.language)).then(
        (result) => {
          setDisableSubmit(false);
          console.log(result);
          if (result?.confirmationNumber) {
            navigate(`/${i18n.language}${t("routes.confirmation")}`);
            setIsActive(false);
          } else if (!result?.confirmationNumber && result?.error === 'DUPLICATE_SIN') {
            setIsActive(false);
            dispatch(setQuestionAnswer(14, "No"));
            navigate(
              `/${i18n.language}${t(
                "routes.not_eligible"
              )}?question=duplicate_application`
            )
          } else {
            setIsActive(false);
            setDisableSubmit(false);
            navigate(
              `/${i18n.language}${t(
                "routes.not_eligible"
              )}?question=unknown_error`
            );
            console.log("NOTHING RETURNED");
          }
        }
      );
    } catch (err) {
      setDisableSubmit(false);
      console.error("Error: " + err?.toString());
      setErrorMessage(err);
    }
  };

  const otherAdultName =
    otherAdultsInformation?.length > 0 && otherAdultsInformation[0].firstName;

  const editOtherAdultOnClick = (e) => {
    e.preventDefault();
    try {
      navigate(
        `/${i18n.language}${t("routes.other_adults_form")}?isSummary=true`
      );
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  return (
    <div>
      <div className="container">
        <div className="row" style={{ paddingTop: "1em" }}></div>
        <BackAnchor backPath={'routes.consent_to_share'} />
        {isActive && (
          <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <CircularProgress size={80} />
              </div>
              <br></br>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                align="center"
              >
                {t("review_summary.submitting_your_application")}
              </Typography>
              <Typography
                id="modal-modal-description"
                align="center"
                sx={{ mt: 2 }}
              >
                {t("review_summary.submitting_your_application_message")}
              </Typography>
            </Box>
          </Modal>
        )}

        <div className="row">
          <div className="col-xs-12 col-sm-8 col-md-12">
            <h1>{t("review_summary.header")}</h1>
          </div>
        </div>

        <div className={styles["content_margin"]}>
          <PersonalInfoSummary />
          <HomeAddressSummary />
        </div>

        {otherAdultName && otherAdultName?.length > 2 && (
          <div className="col-md-12">
            <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
              <div
                style={{
                  display: "flex",
                  flexGrow: 1,
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
              >
                <div style={{ margin: '0px 6px', paddingLeft: '8px' }}>
                  <h3>{t("review_summary.another_adult")}</h3>
                </div>
                <div style={{ margin: '0px 1em' }}>
                  <a
                    id="edit-another-adult"
                    href="#"
                    className={[styles["edit_button"]].join(" ")}
                    onClick={editOtherAdultOnClick}
                    value={t("shared.edit")}
                    name={t("shared.edit")}
                  >
                    <i
                      aria-label={t("shared.edit")}
                      className="fa fa-pencil-alt"
                      aria-hidden="true"
                    ></i>
                    {t("shared.edit")}
                  </a>
                </div>
              </div>
            </div>
            {otherAdultsInformation?.map((adult) => {
              return (
                <div key={adult.localId} className={styles["content_margin"]}>
                  <AnotherAdultSummary otherAdultInformation={adult} otherAdultAssessmentFiles={otherAdultAssessmentFiles} />
                </div>
              );
            })}
          </div>
        )}

        <div className={styles["content_margin"]}>
          <HomeHeatingSummary />
        </div>

        <div className={styles["content_margin"]}>
          <ConfirmationAndAgreementSummary />
        </div>

        <div className={styles["content_margin"]}>
          <SignatureSummary />
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-12">
            <h3>{t("review_summary.information")}</h3>
            {t("review_summary.information_sub_statement")}
          </div>
          <div className="col-xs-12 col-md-12">
            <h3>{t("review_summary.consent_header")}</h3>
            <div>{t("review_summary.optional_statement")}</div>
          </div>
          <div
            className="col-xs-12 col-md-12 ns-checkboxes__item"
            style={{ margin: 5 }}
          >
            <input
              className="ns-checkboxes__input"
              type="checkbox"
              id="ConfirmationCheckBox"
              value="confirm_check"
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                dispatch(setAppProperty("contactedByEfficiency", isChecked));
              }}
              checked={appData.contactedByEfficiency}
            />
            <label
              className="ns-label ns-checkboxes__label"
              htmlFor="ConfirmationCheckBox"
              style={{ padding: 0, marginLeft: "10px" }}
            >
              {t("review_summary.optional_sub_statement_1")}

              {t("review_summary.optional_sub_statement_3")}
            </label>
          </div>
        </div>

        <div className="row">
          <div
            className="col-xs-12 col-sm-8 col-md-12 ns-checkboxes__item"
            style={{ margin: 5 }}
          >
            <input
              className="ns-checkboxes__input"
              type="checkbox"
              id="CyberCheckBox"
              value="confirm_check"
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                dispatch(setAppProperty("cyberSecurity", isChecked));
              }}
              checked={appData.cyberSecurity}
            />
            <label
              className="ns-label ns-checkboxes__label"
              htmlFor="CyberCheckBox"
              style={{ padding: 0, marginLeft: "10px" }}
            >
              {t("review_summary.optional_statement_2")}
            </label>
          </div>
        </div>

        <div className={styles["error_margin"]}>
          <section className="row">
            <div className="col-xs-12">
              <Button
                style={{ backgroundColor: 'green' }}
                showSpinner={disableSubmit}
                className={"btn-lg btn-default"}
                onClick={onContinueClick}
                text={t("review_summary.submit")}
                buttonType={
                  disableSubmit ? "regular_disabled" : "regular_primary"
                }
                disabled={disableSubmit}
              />
              <Button
                className={"btn-lg ns-btn-2nd"}
                style={{ marginLeft: ".7em" }}
                onClick={handleCancel}
                text={t("shared.cancel")}
              />
            </div>
            {disableSubmit && (
              <div className="col-xs-12">
                <i>{t("review_summary.submit_click")}</i>
              </div>
            )}
          </section>
        </div>
        {errMsg === "" ? null : (
          <div className={styles["error_message"]}>
            <div className="form-group has-error" style={{ display: "flex" }}>
              <i
                className={[
                  "fa fa-exclamation-circle",
                  styles["exclamation_position"],
                  styles["exclamation_color"]
                ].join(" ")}
                aria-hidden="true"
              />
              <div className="help-block">{t(errMsg)}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default withTranslation("common")(ReviewConfirmationView);
